module.exports = __webpack_public_path__ + "static/media/6-pin.2b605f9d.svg";